// src/utils/dateUtils.js
export const formatDate = (_date, format = 'MM/DD/YYYY') => {
  if (!_date) return '';

  const date = new Date(_date);
  if (format === 'DDDD') {
    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      timeZone: 'UTC',
    });
  } if (format === 'dddd') {
    return date.toLocaleDateString('en-US', {
      weekday: 'short',
      timeZone: 'UTC',
    });
  }
  if (format === 'MM/DD') {
    return date.toLocaleDateString('en-US', {
      month: '2-digit',
      day: '2-digit',
      timeZone: 'UTC',
    });
  }

  if (format === 'MM-DD-YYYY') {
    return date
      .toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        timeZone: 'UTC',
      })
      .replace(/\//g, '-');
  }

  if (format === 'MM/DD/YY') {
    return date.toLocaleDateString('en-US', {
      year: '2-digit',
      month: '2-digit',
      day: '2-digit',
      timeZone: 'UTC',
    });
  }

  // default: MM/DD/YYYY
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: 'UTC',
  });
};
